module.exports = __webpack_public_path__ + "static/media/rick.46fbdb8a.png";